export const faqItems = [
  {
    id: 1,
    question: 'Onde encontrar assistência técnica para máquinas de solda geomembrana em São Paulo?',
    answer: 'A SoldaGeo oferece suporte técnico pós-venda para todo o Brasil, incluindo São Paulo. Nosso atendimento é realizado via WhatsApp (+55 48 91802091) com técnicos especializados. Realizamos diagnóstico remoto, envio de peças originais e orientação para manutenção preventiva e corretiva em todos os estados brasileiros — sem necessidade de deslocamento.',
    defaultOpen: true,
  },
  {
    id: 2,
    question: 'Qual é a melhor máquina para soldar tanques de piscicultura?',
    answer: 'Para tanques de piscicultura, recomendamos o BT950 ou o BT1600. Ambos trabalham com geomembranas de PEAD e PELBD de 0,5 a 2,0 mm — espessuras mais usadas em tanques de aquicultura. O BT950 (2100W) é ideal para grandes tanques com soldagem contínua, enquanto o BT1600 (1100W) é mais indicado para tanques menores ou trabalhos em locais de acesso restrito. Ambos possuem controle digital de temperatura e solda dupla com canal de teste.',
    defaultOpen: false,
  },
  {
    id: 3,
    question: 'A SoldaGeo entrega máquinas de solda geomembrana para todos os estados do Brasil?',
    answer: 'Sim. A SoldaGeo realiza envio para todos os 26 estados brasileiros e o Distrito Federal — incluindo Amazonas, Pará, Mato Grosso, Goiás, Bahia, Minas Gerais, Rio de Janeiro, São Paulo, Rio Grande do Sul e demais regiões. Trabalhamos com transportadoras especializadas para garantir a entrega segura dos equipamentos. O prazo médio é de 3 a 10 dias úteis dependendo do estado de destino.',
    defaultOpen: false,
  },
  {
    id: 4,
    question: 'Qual máquina de solda geomembrana é indicada para aterros sanitários e projetos de mineração?',
    answer: 'Para aterros sanitários e mineração, onde as geomembranas são mais espessas (1,5 a 3,0 mm de PEAD), recomendamos o BT950 (2100W, 5–8 m/min) ou o Weldy WGW300 (2100W, 5–9 m/min). Para emendas de reforço, cantos e reparos, a Extrusora EX3 (3400W, 700°C) é indispensável. Esses modelos atendem às normas ABNT NBR 16199 e NBR 15352 de impermeabilização de aterros e barragens de rejeitos.',
    defaultOpen: false,
  },
  {
    id: 5,
    question: 'Como funciona a garantia e o suporte técnico das máquinas SoldaGeo?',
    answer: 'Todos os equipamentos SoldaGeo possuem garantia de 6 a 12 meses contra defeitos de fabricação. O suporte técnico pós-venda é realizado por nossa equipe especializada via WhatsApp, com atendimento em todo o Brasil. Disponibilizamos peças de reposição originais, manuais técnicos em português e orientação para calibração e manutenção preventiva.',
    defaultOpen: false,
  },
  {
    id: 6,
    question: 'Qual a diferença entre solda por cunha quente e solda por extrusão?',
    answer: 'A solda por cunha quente (hot wedge welding) usa uma cunha metálica aquecida que funde as duas folhas simultaneamente, criando uma solda dupla com canal de teste de pressão — é o método mais rápido para grandes áreas planas. A solda por extrusão aplica fio de PEAD fundido sobre a emenda, gerando alta resistência mecânica — indicada para cantos, junções, reparos e geomembranas espessas acima de 2 mm.',
    defaultOpen: false,
  },
  {
    id: 7,
    question: 'Qual a temperatura ideal para soldar geomembrana PEAD?',
    answer: 'A temperatura ideal para soldar geomembrana de PEAD varia entre 280°C e 380°C na cunha, dependendo da espessura do material, velocidade de soldagem e condições ambientais — conforme a ABNT NBR 16199. Máquinas como o BT950 e o Weldy WGW300 permitem ajuste fino de 0 a 500°C, garantindo soldas perfeitas em qualquer condição de campo.',
    defaultOpen: false,
  },
  {
    id: 8,
    question: 'Como solicitar um orçamento para máquina de solda geomembrana?',
    answer: 'O orçamento é rápido e sem compromisso. Basta entrar em contato via WhatsApp no número +55 48 91802091 ou pelo botão "Pedir Orçamento" em qualquer página do site. Nossa equipe técnica responde com agilidade e indica o equipamento ideal para o seu projeto.',
    defaultOpen: false,
  },
];
